<template>
    <!-- AUDITS CHECKLIST PAGE -->
    <div v-if="checklist && checklist.sections && Object.values(checklist.sections).length > 0" ref="container" class="audit-content scrollbar right" :class="[$mq]">
        <div class="top-and-tabs-container">
            <div class="top-container" :class="{ 'opened-info': infoIsOpen }">
                <AppccTopDetail :auditScore="template.config" :hasMoreOptions="true" @infoOpened="infoOpened" @deleteButton="deleteAudit" @reopenButton="reopenAudit" @settingsButton="settingsRegister" @backButton="back" :audit="checklist" :userInfo="checklist.employee" :title="checklist.title" :createdAt="checklist.created_date" :completed="checklist.complete_date" :hasDelete="true" :hasReopen="canShowReopen()" />
            </div>

            <!-- NON CONFORMITY BANNER -->
            <section v-if="itemsWithActionPlans && itemsWithActionPlans.length > 0" class="non-conformity-banner-container">
                <BannerWithButton :image="bannerImage" :backgroundColor="bannerBackgroundColor" :message="nonConformityBannerMessage" :messageColor="bannerMessageColor" :buttonText="nonConformityBannerButtonText" :buttonColor="bannerButtonColor" @buttonAction="handleNonConformityFilter" />
            </section>
        </div>

        <!-- AUDITS sections and items -->
        <div class="sections-and-items-wrapper">
            <SectionsAndItems :sections="onlyNonConformities ? sectionsAndItemsWithActionPlans : Object.values(checklist.sections)" :checklist="checklist" :infoIsOpen="infoIsOpen" :templateConfig="template.config" :type="type" :showErrors="showErrors" :itemsWithActionPlansQuantity="itemsWithActionPlans.length" :notes="notes" :doneSectionsIds="doneSectionsIds" :skip-scroll-to-first-pending-section="isReturningFromActionPlan" @recover-values="recoverValues" />
        </div>
    </div>

    <!-- EMPTY PAGE -->
    <div v-else>
        <div class="audit-content hide-scrollbar right empty">
            <EmptyPage :buttonText="$t('empty_pages.return_audits')" @buttonAction="back()" buttonClass="back" :type="'error'" :title="$t('assets.overlay.timeout.message')" :description="$t('empty_pages.error_audit')" />
        </div>
    </div>
</template>

<script>
import EmptyPage from '@/components/layout/EmptyPage.vue'
// import answer from '@/components/domain/tasks/answer'
import UserTag from '@/components/layout/UserTag'
import AppccTopDetail from '@/components/layout/AppccTopDetail'
import SectionsAndItems from '@/components/domain/audit/SectionsAndItems.vue'
import { FORMAT } from '@/constants'
import BannerWithButton from '@/components/domain/ui/BannerWithButton.vue'
import { formatDisplayDateFromStore } from '@/utils/dateFormatters'

export default {
    components: { UserTag, EmptyPage, AppccTopDetail, SectionsAndItems, BannerWithButton },
    props: {
        gId: { type: String },
        showErrors: {
            type: Boolean
        },
        openSection: {
            type: Boolean
        }
    },
    data() {
        return {
            // collapsedInfo: false,
            type: 2,
            firstTime: true,
            // closedSections: {},
            infoIsOpen: false,
            showNonApply: true,
            showTabs: false,
            tabsOptions: {
                AUDIT: 1,
                ACTION_PLAN: 2
            },
            tabSelected: null,
            FORMAT: FORMAT,
            onlyNonConformities: false,
            hasHandledActionPlanReturnScroll: false,
            isReopening: false
        }
    },
    computed: {
        checklist() {
            const checklist = this.$store.getters['audit/getById'](this.gId)

            if (checklist) {
                // checklist.employee.avatar = css_image_url + 'avatar/' + checklist.employee.avatar
                if (this.firstTime) {
                    this.firstTime = false

                    for (var k in checklist.sections) {
                        var section = { ...checklist.sections[k] }

                        // this.closedSections[section.section_id] = false
                    }
                }
            }
            if (checklist == undefined) {
                this.$bar.hide()
            }
            return checklist
        },
        template() {
            // log('audtis templates -> ', this.$store.getters['audit/getTemplates'])
            var templates = this.$store.getters['audit/getTemplateById'](this.$route.params.id)
            // var showScore = { show_score: 0 }
            // templates.config = showScore

            return templates
        },
        user() {
            var userID = this.$store.getters['loginUser/getLocalEmployee']
            if (userID) {
                return this.$store.getters['employee/getEmployee'](userID)
            }
        },
        sections() {
            return Object.values(this.checklist.sections)
        },
        roles() {
            return this.$store.getters['employee/getAllRoles']
        },
        sectionsAndItemsWithActionPlans() {
            const sections = Object.values(this.checklist.sections)

            return sections
                .map((section) => {
                    const sectionItems = section.items || {}
                    const allItems = Object.values(sectionItems)
                    const nonConformityIds = new Set(allItems.filter((item) => this.isNonConformityItem(item)).map((item) => item.item_id))

                    if (nonConformityIds.size === 0) {
                        return null
                    }

                    const filteredItems = allItems.filter((item) => {
                        if (nonConformityIds.has(item.item_id)) {
                            return true
                        }
                        if (!item.is_visible) {
                            return false
                        }
                        return this.hasNonConformityAncestor(item, sectionItems, nonConformityIds)
                    })

                    if (filteredItems.length === 0) {
                        return null
                    }

                    return {
                        ...section,
                        items: filteredItems
                    }
                })
                .filter((section) => section !== null)
        },
        itemsWithActionPlans() {
            let audit = this.$store.getters['audit/getById'](this.gId)

            const sections = Object.values(audit.sections)

            const items = sections.flatMap((section) => Object.values(section.items).filter((item) => item.alerts_triggers !== false && item.reference.type == 5))

            return items
        },
        finalScore() {
            if (this.checklist && this.checklist.finalScore) {
                return this.checklist.finalScore.name
            } else return ''
        },
        finalScorePercent() {
            if (this.checklist && this.checklist.score) {
                return this.checklist.score
            } else return '-'
        },
        notes() {
            return this.$store.getters['audit/getNotesById'](this.gId)
        },
        doneSectionsIds() {
            if (!this.checklist.sections) {
                return []
            }

            const checklistSections = Object.values(this.checklist.sections)

            let doneSectionsIds = []

            for (const section of checklistSections) {
                const itemsToCheck = Object.values(section.items).filter((item) => !item.parent_id || (item.parent_id && item.is_visible))

                if (itemsToCheck.every((item) => this.isItemCompleted(item))) {
                    doneSectionsIds.push(section.section_id)
                }
            }

            return doneSectionsIds
        },
        firstNotDoneSectionId() {
            if (!this.checklist.sections || !this.doneSectionsIds) {
                return null
            }

            const allSectionsIds = Object.keys(this.checklist.sections)

            return allSectionsIds.find((sectionId) => !this.doneSectionsIds.includes(sectionId))
        },
        isReturningFromActionPlan() {
            const query = this.$route.query || {}
            return Boolean(query.fromActionPlanChecklist && query.nonConformityId)
        },
        nonConformityBannerMessage() {
            const nonConformityCount = this.itemsWithActionPlans && this.itemsWithActionPlans.length > 0 ? this.itemsWithActionPlans.length : 0

            if (nonConformityCount > 1) {
                if (this.onlyNonConformities) {
                    return this.$t('action_plans.non_conformity_filter.applied.message_n_non_conformity', {
                        non_conformity_count: nonConformityCount.toString()
                    })
                } else {
                    return this.$t('action_plans.non_conformity_filter.not_applied.message_n_non_conformity', {
                        non_conformity_count: nonConformityCount.toString()
                    })
                }
            } else {
                if (this.onlyNonConformities) {
                    return this.$t('action_plans.non_conformity_filter.applied.message_one_non_conformity', {
                        non_conformity_count: nonConformityCount.toString()
                    })
                } else {
                    return this.$t('action_plans.non_conformity_filter.not_applied.message_one_non_conformity', {
                        non_conformity_count: nonConformityCount.toString()
                    })
                }
            }
        },
        nonConformityBannerButtonText() {
            if (this.onlyNonConformities) {
                return this.$t('action_plans.non_conformity_filter.applied.button')
            } else {
                return this.$t('action_plans.non_conformity_filter.not_applied.button')
            }
        },
        bannerImage() {
            return this.onlyNonConformities ? '/img/illustrations/Andy06.svg' : '/img/illustrations/Andy01.svg'
        },
        bannerBackgroundColor() {
            return this.onlyNonConformities ? 'banner-background-color-warning' : 'banner-background-color-blue'
        },
        bannerMessageColor() {
            return this.onlyNonConformities ? 'banner-message-color-warning' : 'banner-message-color-blue'
        },
        bannerButtonColor() {
            return this.onlyNonConformities ? 'banner-button-color-warning' : 'banner-button-color-blue'
        }
    },
    methods: {
        handleNonConformityFilter() {
            this.onlyNonConformities = !this.onlyNonConformities
        },
        scrollToNonConformityItem(itemId) {
            const nonConformityItem = document.getElementById(itemId)
            if (nonConformityItem) {
                nonConformityItem.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
        },
        /**
         * Scrolls to the non-conformity only when returning from its Action Plan.
         * The route query is a one-shot navigation intent and must be consumed afterwards.
         */
        maybeScrollToNonConformityFromActionPlan() {
            const query = this.$route.query || {}
            const fromActionPlanChecklist = query.fromActionPlanChecklist
            const nonConformityId = query.nonConformityId

            if (!fromActionPlanChecklist || !nonConformityId) {
                return
            }

            if (!this.checklist || !this.checklist.sections) {
                return
            }

            if (this.hasHandledActionPlanReturnScroll) {
                return
            }

            this.hasHandledActionPlanReturnScroll = true

            this.$nextTick(() => {
                this.scrollToNonConformityItem(nonConformityId)
                this.consumeActionPlanReturnQuery()
            })
        },
        consumeActionPlanReturnQuery() {
            const query = { ...this.$route.query }

            if (!query.fromActionPlanChecklist && !query.nonConformityId) {
                return
            }

            delete query.fromActionPlanChecklist
            delete query.nonConformityId

            this.$router.replace({ path: this.$route.path, query }).catch((error) => {
                if (error && error.name !== 'NavigationDuplicated') {
                    return
                }
            })
        },
        /**
         * Determina si un item del checklist está completado.
         * Los items tipo LINK y RESOURCE se consideran siempre completados porque no guardan un valor.
         * @param {Object} item - El item del checklist a evaluar
         * @returns {boolean} - true si el item está completado, false en caso contrario
         */
        isItemCompleted(item) {
            return (item.value !== null && item.value !== '') || item.apply == 0 || item.type === FORMAT.LINK || item.type === FORMAT.RESOURCE
        },
        /**
         * Un item es no conformidad si tiene triggers de alerta y un plan de acción asociado.
         * @param {Object} item
         * @returns {boolean}
         */
        isNonConformityItem(item) {
            return item.alerts_triggers !== false && item.reference && item.reference.type == 5
        },
        /**
         * Recorre parent_id para saber si el item cuelga de una no conformidad de la misma sección.
         * @param {Object} item
         * @param {Object} sectionItems
         * @param {Set} nonConformityIds
         * @returns {boolean}
         */
        hasNonConformityAncestor(item, sectionItems, nonConformityIds) {
            let current = item
            while (current && current.parent_id) {
                if (nonConformityIds.has(current.parent_id)) {
                    return true
                }
                current = sectionItems[current.parent_id]
            }
            return false
        },
        settingsRegister() {
            const self = this
            this.$popup.itemSettings({
                itemSettings: {
                    noApply: {
                        label: self.$t('popup.item_settings.no_apply'),
                        value: self.showNonApply
                    }
                },
                callSave: (settings) => {
                    const itemSettings = settings.itemSettings
                    self.showNonApply = itemSettings.noApply.value
                    self.$popup.close()
                }
            })
        },
        infoOpened() {
            this.infoIsOpen = !this.infoIsOpen
        },
        back() {
            this.$emit('update-show-errors', !this.showErrors)
            this.$emit('updateToggle', !this.openSection)
            this.$router.push({
                name: 'AuditDetail',
                params: { id: this.$route.params.id }
            })
        },
        getString(str) {
            return this.$t(str)
        },
        getStringVariables(str, params) {
            return this.$t(str, params)
        },
        getStringPlural(str, pos) {
            return this.$tc(str, pos)
        },
        getStringVariable(str, pos) {
            return this.$t(str, { s: pos })
        },
        getStringPluralVariable(str, pos, text) {
            return this.$tc(str, pos, { s: text })
        },
        recoverValues() {
            var self = this
            self.$overlay.loading()

            self.$store.dispatch('audit/recoverValues', { check: self.gId }).then(function (response) {
                self.$overlay.hide()
                self.$snackbar.info({ message: self.$t('tooltip.done') })
            })
        },
        currentEmployee() {
            var emp_id = this.$store.getters['loginUser/getLocalEmployee']

            if (emp_id) {
                var emp = this.$store.getters['employee/getEmployee'](emp_id)
            } else {
                var emp = this.$store.getters['loginUser/getLocalLocation']
            }

            return emp
        },
        hasManagePermission() {
            if (!this.user || !this.user.rol) {
                return false
            }

            const userRole = this.$store.getters['employee/getRol'](this.user.rol)
            if (userRole && parseInt(userRole.level, 10) >= 8) {
                return true
            }

            const nRoles = this.checklist && this.checklist.config && Array.isArray(this.checklist.config.nRoles) ? this.checklist.config.nRoles : null
            if (!nRoles || nRoles.length === 0) {
                return true
            }

            return nRoles.some((role) => role.roleId == this.user.rol && role.permissions && role.permissions.includes('m'))
        },
        rolesWithManagePermissions() {
            const roles = []
            const nRoles = this.checklist && this.checklist.config && Array.isArray(this.checklist.config.nRoles) ? this.checklist.config.nRoles : []
            const manageRoleIds = nRoles.filter((role) => role.permissions && role.permissions.includes('m')).map((role) => role.roleId)

            Object.values(this.roles || {}).forEach((role) => {
                if (manageRoleIds.includes(role.id)) {
                    roles.push(role.name)
                }
            })

            return roles.join(', ').replace(/,(?=[^,]*$)/, ' ' + this.$t('answer.or'))
        },
        auditRolePermissions() {
            const nRoles = this.checklist && this.checklist.config && Array.isArray(this.checklist.config.nRoles) ? this.checklist.config.nRoles : null
            if (!nRoles || nRoles.length === 0) {
                return null
            }

            return nRoles
        },
        canReopenCompletedAudit() {
            const nRoles = this.auditRolePermissions()
            if (!nRoles || !this.user || !this.user.rol) {
                return false
            }

            const userRole = this.$store.getters['employee/getRol'](this.user.rol)
            if (userRole && parseInt(userRole.level, 10) >= 8) {
                return true
            }

            return nRoles.some((role) => role.roleId == this.user.rol && role.permissions && role.permissions.includes('m'))
        },
        canShowReopen() {
            return this.canReopenCompletedAudit() && !this.isReopening
        },
        reopenAudit() {
            if (this.isReopening) {
                return
            }

            if (!this.canReopenCompletedAudit()) {
                this.$popup.alert({
                    message: this.$t('answer.timing.not_has_role_permission', {
                        name: this.user ? this.user.name : '',
                        roles: this.rolesWithManagePermissions()
                    })
                })
                return
            }

            if (!fnCheckConnection()) {
                this.$popup.alert({
                    message: this.$t('popup.audit.offline_reopen')
                })
                return
            }

            this.isReopening = true
            this.$store
                .dispatch('audit/reopen', { check: this.gId })
                .then((response) => {
                    if (response && response.status) {
                        this.$emit('reopened')
                        return
                    }

                    this.$snackbar.error({ message: this.$t('tooltip.error') })
                })
                .catch(() => {
                    this.$snackbar.error({ message: this.$t('tooltip.error') })
                })
                .finally(() => {
                    this.isReopening = false
                })
        },
        deleteAudit() {
            if (!this.hasManagePermission()) {
                this.$popup.alert({
                    message: this.$t('answer.timing.not_has_role_permission', {
                        name: this.user ? this.user.name : '',
                        roles: this.rolesWithManagePermissions()
                    })
                })
                return
            }

            if (!fnCheckConnection()) {
                this.$popup.alert({
                    message: this.$t('popup.audit.offline_remove')
                })
                return
            }

            var self = this
            var employee = self.currentEmployee()

            if (!self.$store.getters['hasAccess'](employee.id, 1)) {
                self.$popup.access({
                    list: self.$store.getters['employee/getLoginUsers'](1),
                    callAfterAccess: function (response) {
                        if (response.status) {
                            self.$popup.close()
                            self.popupDeleteAudit(response.emp_id)
                        }
                    }
                })
            } else {
                self.popupDeleteAudit(employee.id)
            }
        },
        popupDeleteAudit(emp_id) {
            var self = this
            var relItem = self.refTask ? self.refTask.task_id : false
            // Validate user rol is in template audit
            var template = self.$store.getters['audit/getTemplateById'](self.$route.params.id)
            var rolEmployee = self.$store.getters['employee/getRol'](this.user.rol)
            var auditTemplateHasRoleUser = false

            var templateRoles = template.config.roles
            if (typeof templateRoles === 'undefined' || templateRoles.length == 0 || templateRoles.includes(rolEmployee.id)) {
                auditTemplateHasRoleUser = true
            }

            if (auditTemplateHasRoleUser) {
                self.$popup.confirm({
                    message: self.$t('popup.delete.title'),
                    textSave: self.$t('popup.delete.text_save'),
                    textCancel: self.$t('popup.delete.text_cancel'),
                    callSave: function () {
                        self.$overlay.loading()
                        self.$store
                            .dispatch('audit/delete', {
                                check: self.gId,
                                audit: self.gId,
                                emp: emp_id,
                                ref_item: relItem,
                                template: self.checklist.template_id
                            })
                            .then(function (response) {
                                if (response) {
                                    self.$popup.close()
                                    self.$overlay.hide()
                                    self.$snackbar.success({
                                        duration: 5000,
                                        closeable: true,
                                        message: self.$t('popup.audits.removed_successfully')
                                    })

                                    self.$router.push({
                                        name: 'AuditDetail',
                                        params: { id: self.checklist.template_id }
                                    })
                                }
                            })
                    }
                })
            } else {
                self.$popup.alert({
                    closable: false,
                    blocking: false,
                    message: self.$t('popup.audits.role_not_allowed'),
                    textSave: self.$t('popup.audit.error.alert_save'),
                    callSave: function (response) {
                        self.$popup.close()
                    }
                })
            }
        },
        toSection(id) {
            var scroll = {
                container: this.$refs.container,
                target: document.getElementById(id),
                offset: this.checklist.sections.length > 0 ? -165 : -105
            }

            this.$root.scrollTo(scroll)
        },
        redirectPath(firstResult) {
            return this.$root.redirectPath(firstResult)
        },
        employee(id) {
            return this.$store.getters['employee/getEmployee'](id)
        }
    },
    filters: {
        moment: function (date, format) {
            if (!date) {
                return ''
            }

            if (format) {
                return moment(date).format(format)
            }

            return formatDisplayDateFromStore(date, { includeTime: false, emptyValue: '' })
        }
    },
    created() {
        if (localStorage.getItem('showNonApply') != undefined) {
            this.showNonApply = localStorage.getItem('showNonApply') == 'true' ? true : false
        }
    },
    mounted() {
        this.tabSelected = this.tabsOptions.AUDIT
    },
    watch: {
        showNonApply(newValue, oldValue) {
            if (newValue !== oldValue) {
                localStorage.setItem('showNonApply', newValue)
                this.$store.commit('checklist/setShowNoApply', newValue)
            }
        },
        checklist: {
            handler() {
                this.maybeScrollToNonConformityFromActionPlan()
            },
            immediate: true
        },
        '$route.query.fromActionPlanChecklist'(newValue) {
            if (newValue) {
                this.hasHandledActionPlanReturnScroll = false
                this.maybeScrollToNonConformityFromActionPlan()
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#menu-aux.portrait {
    display: none;
}
</style>
<style lang="scss">
#content.audit.detail {
    $column-width: 0%;
    $column-max-width: 0px;
    $content-width: 100%;
    height: min-content;

    > .audit-content {
        position: relative;
        $top-info: 80px;
        $resume-width: rem(230px);
        padding-top: 0;
        padding-bottom: 0 !important;
        width: calc(#{$content-width}) !important;
        min-width: calc(100% - #{$column-max-width}) !important;
        overflow: hidden;
        padding: 8px;
        height: calc(100% - 75px); // 75px is the height of the section of buttons at the bottom of the page
        display: flex;
        flex-direction: column;
        gap: 16px;

        @media (min-width: 901px) {
            height: calc(100% - 60px); // 60px is the height of the section of buttons at the bottom of the page
        }

        .top-and-tabs-container {
            position: relative;
            width: 100%;
            max-width: 100%;
            z-index: 0;
            flex-shrink: 0;
        }

        .sections-and-items-wrapper {
            flex: 1;
            min-height: 0;
            display: flex;
            flex-direction: column;

            .audits-sections-and-items {
                flex: 1;
                min-height: 0;
                display: flex;
                flex-direction: column;

                .template-sections,
                .progress-bar-section,
                .sections-searchbar-container {
                    flex-shrink: 0;
                }
            }
        }

        .audits-tabs-container {
            position: relative;
            // position: absolute;
            display: grid;
            place-items: center;
            // padding: 8px 0px;
            // padding-bottom: 8px;
            width: 100%;
            max-width: 100%;

            .tabs {
                background-color: $color-white;
                width: 100%;
                max-width: 400px;
                // height: 50px;
                border-radius: 4px;
                display: grid;
                grid-template-columns: 1fr 1fr;
                padding: 4px;
                gap: 4px;
                min-height: 50px;
                max-height: fit-content;

                @media (min-width: 768px) {
                    width: 400px;
                    max-width: 400px;
                }

                .tab {
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                    background-color: $color-white;
                    font-size: 16px;
                    line-height: 19.12px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 2px;
                    position: relative;
                    max-height: 100%;
                    justify-content: center;

                    .title {
                        font-weight: bold;
                    }

                    .items-number {
                        position: absolute;
                        background-color: $color-error-500;
                        color: $color-white;
                        top: 5px;
                        right: 2px;
                        border-radius: 50%;
                        font-size: 14px;
                        display: grid;
                        place-items: center;
                        width: 32px;
                        height: 31px;
                    }

                    .text {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 2px;
                        justify-content: center;
                    }
                }

                .action-plan {
                    padding-right: 32px;
                }

                button:hover {
                    background-color: $color-white;
                }

                .selected {
                    background-color: $main-t80;
                }

                .selected:hover {
                    background-color: $main-t80;
                }
            }
        }

        .detail-box {
            $sidebar-size: 40px;
            $collapse-button: 40px;
            $content-padding: 0px;
            $detail-bg: $default-bg-color;
            $detail-text-color: $main-dark;
            // padding: 8px 8px 8px 0px;
            // padding-left: $content-padding;
            // El scroll vive en #exam; este wrapper solo acota altura.
            overflow: hidden;
            background-color: $detail-bg;
            height: 100%;
            min-height: 0;
            flex: 1;

            --progress-bar-height: 32px;

            @media (min-width: 768px) {
                --progress-bar-height: 52px;
            }

            .list-info {
                $action-size: rem(60px);
                @include default-box-shadow();
                @include display-flex();
                @include justify-content(flex-end);
                @include align-items();
                @include flex-direction(row);
                @include flex-wrap(nowrap);
                background-color: shade($default-bg-color, 5%);
                position: fixed;
                z-index: 9;
                width: calc(100% - #{$column-max-width} - #{$menu-tools-min} - #{$content-padding} - #{$scroll-width});
                height: $action-size;

                .action {
                    @include interaction();
                    @include font-size(xs);
                    font-family: $text-bold;
                    color: #444;
                    text-align: center;
                    display: block;
                    background-color: shade($default-bg-color, 7%);
                    width: $action-size;
                    height: $action-size;
                    padding: ($action-size - rem(20px)) 6px 2px 6px;
                    margin: 0 9px;

                    @include bgHover(shade($default-bg-color, 7%));

                    &.delete {
                        @include background($image: img('delete_alert.svg'), $size: 24px, $position: top 9px center);
                    }
                }
            }

            .exam {
                @include border-radius($default-border-radius);
                // padding: 8px 0px 8px 8px;
                height: 100%;
                overflow: auto;

                .minimize {
                    opacity: 0.85;
                    margin-bottom: 0px;
                    margin-top: 0px;

                    &:hover {
                        opacity: 1;
                    }

                    .section-title {
                        @include font-size(s);

                        // &.expand:before {
                        //     background-image: img('more_primary.svg');
                        // }
                    }
                }

                .empty-page-content {
                    .content-message {
                        padding: 16px 24px !important;
                        width: fit-content !important;

                        .description {
                            padding-top: 0px !important;
                            font-size: 18px !important;
                        }
                    }
                }

                .get-last-values {
                    text-align: center;

                    .message {
                        @include interaction();
                        @include border-radius($default-border-radius);
                        @include background($color: $main-t80, $image: img('download_primary.svg'), $position: right 12px center, $size: 22px);
                        @include font-size(m);
                        font-family: $text;
                        color: $main-dark;
                        padding: 12px 42px 12px 12px;
                        display: inline-block;

                        @include bgHover($main-t80);
                    }
                }

                .section {
                    $section-score-width: 80px;
                    width: 100%;
                    max-width: 100%;

                    // padding: 6px;
                    // width: 94%;
                    // margin: 12px auto;
                    // padding-bottom: 20px;

                    .section-title {
                        @include font-size(s);
                        font-family: $text;
                        color: $main-dark;

                        // width: calc(100% - #{$section-score-width});
                        // margin-bottom: 4px;

                        &.expand-full {
                            width: 100%;
                        }

                        // &:before {
                        //     @include background($color: $main-t80, $image: img('less_primary.svg'), $size: 10px);
                        //     @include border-radius(3px);
                        //     content: '';
                        //     display: inline-block;
                        //     width: 18px;
                        //     height: 18px;
                        //     margin-right: 6px;
                        //     margin-bottom: -2px;
                        // }
                    }

                    .section-score {
                        display: inline-block;
                        width: $section-score-width;
                        text-align: right;

                        .points {
                            @include font-size(l);
                            font-family: $conden-bold;
                            color: $main;
                        }

                        .total {
                            @include font-size(sm);
                            font-family: $conden-bold;
                            color: $neutro-s90;
                            padding-right: 6px;
                        }

                        .percentage {
                            font-family: $text-medium;
                            color: $main;
                            background-color: #fff;
                            padding: 6px;
                            border-radius: 4px;
                            @include font-size(xs);
                            position: relative;
                            top: -2px;
                        }
                    }

                    .section-content {
                        @include display-flex();
                        @include flex-direction(row);
                        @include flex-wrap(wrap);
                        @include border-radius($default-border-radius);

                        .question-score {
                            @include display-inline-flex();
                            // @include justify-content();
                            @include align-items();
                            @include font-size(m);
                            margin: 20px auto;
                            font-family: $text;
                            color: $main;
                            width: 80px;
                            height: 50px;
                        }
                    }

                    .section-total {
                        width: 100%;
                        text-align: right;

                        .text {
                            @include font-size(sm);
                            font-family: $text-bold;
                            color: $main-dark;
                        }

                        .total {
                            @include styScore();
                            @include font-size(ml);
                            font-family: $text-bold;
                            color: $main;
                            text-align: center;
                            display: inline-block;
                            width: 80px;
                            padding: 6px;
                        }
                    }

                    &.closed {
                        //height: 50px;
                        // margin: 12px auto;

                        // .section-title:before {
                        //     background-image: img('more_primary.svg');
                        // }

                        .section-content {
                            visibility: hidden;
                            display: none;
                            height: 0;
                            opacity: 0;

                            // .question, .question-score {
                            //   display: none;
                            // }
                        }
                    }
                }
            }
        }

        .check-description {
            @include background($color: shade($default-bg-color, 4%), $image: img('file_attach_aaaaaa.svg'), $position: left 12px center, $size: 35px);
            padding: 16px 20px 16px 56px;
            margin: 0 6px 0 12px;
            max-height: 30vh;
            overflow-y: auto;
            border-radius: 4px;

            .alex {
                @include background($image: img('alexhead_04.svg'), $size: contain, $position: left bottom);
                width: 40px;
                height: 40px;
                display: inline-block;
                margin-right: 6px;
            }

            .message {
                @include font-size(xs);
                // line-height: 20px;
                font-family: $text;
                color: $main-dark;
                display: inline-block;
                overflow: visible;
                width: auto;
                min-height: 20px;
                height: auto;

                @media (min-width: 768px) {
                    @include font-size(sm);
                }

                .more {
                    color: $main-t20;
                    cursor: pointer;
                }
            }
        }
        .top-container {
            background-color: $default-bg-color;
            width: 100%;
            max-width: 100%;
            height: auto;
            padding-bottom: 16px;

            // position: sticky;
            position: relative;
            top: 0px;

            .non-conformity-banner-container {
                height: fit-content;
                width: 100%;
                padding-bottom: 8px;
            }
        }

        &.desktop {
            .top-container {
                background-color: $default-bg-color;
                width: 100%;
                padding-bottom: 10px;
                max-height: 150px;
            }

            // Calcular la altura de todo el contenido top que es fijo para el listado
            .detail-box {
                // height: calc(100% - 160px);
                // &.with-sections {
                //     // height: calc(100% - 200px);

                //     // &.opened-info {
                //     //     // height: calc(100% - 255px);
                //     // }
                // }

                // &.opened-info {
                //     height: calc(100% - 195px);
                // }

                .section {
                    .section-title {
                        @include font-size(ml);
                    }
                }

                .section-score {
                    .percentage {
                        @include font-size(m, $important: true);
                    }
                }
            }
        }

        &.landscape {
            // .top-container {
            //     // padding-left: 11px;
            //     // padding-right: 11px;
            // }
            // Calcular la altura de todo el contenido top que es fijo para el listado
            .detail-box {
                .section {
                    .section-title {
                        @include font-size(ml);
                    }
                }

                .section-score {
                    .percentage {
                        @include font-size(m, $important: true);
                    }
                }
            }
        }
    }

    > .column.left {
        $content-space: 6px;
        width: $column-width !important;
        max-width: $column-max-width !important;
    }

    // TODO REVIEW
    // .question.child {
    //     // margin: rem(15px) auto;

    //     // &:nth-of-type(2) {
    //     //     //   width: 85% !important;
    //     //     //   margin-left: 9%;
    //     // }
    // }

    .question {
        // margin: rem(15px) auto;+
        margin: 0px;
        padding: 0px 0px 0px 16px;
    }
}
</style>

<!-- PORTRAIT STYLES -->
<style lang="scss" scoped>
#content.audit {
    &.detail {
        .audit-content.portrait {
            // height: 100%;

            .progress-bar-section {
                padding-right: 0px !important;
            }

            .progress-bar-container {
                padding-right: 0px !important;
                padding-left: 0px !important;
            }

            .detail-box {
                // padding-top: 60px !important;
                background: transparent;
                // height: calc(100% - 175px);

                // &.opened-info {
                //     height: calc(100% - 220px);
                // }

                .message {
                    padding-left: 10px;
                }

                .exam {
                    .section {
                        width: 100%;
                        $section-score-width: 80px;
                        margin: 8px auto;

                        .section-title {
                            // width: calc(100% - #{$section-score-width});
                            @include font-size(xs);
                            line-height: normal;

                            &.expand-full {
                                width: 100%;
                            }
                        }

                        .section-score {
                            width: $section-score-width;
                        }
                    }

                    .justify-description,
                    .check-available {
                        padding: 8px 20px 8px 50px;
                        background-size: 25px;
                        background-position: left 10px center;

                        .message {
                            @include font-size(xs);
                            line-height: 1rem;
                            width: calc(100% - 100px);
                        }

                        .action {
                            width: 100px;
                            @include font-size(xs);
                            line-height: 0.75rem;
                        }
                    }

                    .check-available {
                        .message {
                            width: 100%;
                            max-width: 100%;
                        }
                    }
                    .check-description {
                        padding: 8px 20px 8px 34px;
                        background-size: 25px;
                        background-position: left 4px center;
                        margin: 0px !important;
                        max-height: 30vh;
                        overflow-y: auto;
                        border-radius: 4px;

                        .message {
                            @include font-size(xs);
                            line-height: 1rem;
                        }
                    }

                    .get-last-values {
                        .message {
                            @include font-size(xs);
                            line-height: normal;
                        }
                    }
                }

                &.not-saved {
                    padding-bottom: 0px;
                }

                // &.opened-info {
                //     height: calc(100% - 115px);
                //     padding-bottom: 0px;
                // }
                &.with-sections {
                    padding-bottom: 0px;

                    // &.opened-info {
                    //     height: calc(100% - 255px);
                    // }
                }
            }

            .top-container {
                height: auto;
                max-height: none;
            }
        }
    }
}
</style>
